import { render, staticRenderFns } from "./PopUp.vue?vue&type=template&id=fbc90df2"
import script from "./PopUp.vue?vue&type=script&lang=js"
export * from "./PopUp.vue?vue&type=script&lang=js"
import style0 from "./PopUp.vue?vue&type=style&index=0&id=fbc90df2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports